// extracted by mini-css-extract-plugin
module.exports = {"inherit":"getFontStyle_inherit__yB0hb","normal":"getFontStyle_normal__2Yioa","italic":"getFontStyle_italic__NkkHB","oblique":"getFontStyle_oblique__3bfQ7"};